import React from 'react'

import './index.scss'

const LoadMore = (props) => <a {...props} className="load-more-btn">加载更多</a>

export default LoadMore
